import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { BotDefaultLocale } from '@feedyou-ai/feedbot-schema'
import { getBotDefaultLocaleSelector } from '../selectors/selectors'

export function useBotDefaultLocale() {
  return useSelector<RootState, BotDefaultLocale | undefined>(getBotDefaultLocaleSelector)
}
